// extracted by mini-css-extract-plugin
module.exports = {"mobile_support":"true"};